export default "__VITE_ASSET__JiH1Oiz8__"